/* global jQuery */
/**
 * Setup the carousel slider for single listings
 */
const init = () => {
	const slider = document.querySelector('.royalSlider');
	if (!slider) {
		return;
	}
	jQuery(document).ready(function ($) {
		$(slider).royalSlider({
			keyboardNavEnabled: true,
			fullscreen: {
				enabled: true,
				nativeFS: true,
			},
			controlNavigation: 'thumbnails',
			autoScaleSlider: true,
			autoScaleSliderHeight: 800,
			imgHeight: 800,
			loop: false,
			imageScaleMode: 'fit',
			imageAlignCenter: true,
			navigateByClick: true,
			numImagesToPreload: 2,
			arrowsNav: true,
			arrowsNavAutoHide: false,
			arrowsNavHideOnTouch: true,
			usePreloader: false,
			fadeinLoadedSlide: true,
			globalCaption: true,
			globalCaptionInside: false,
			thumbs: {
				appendSpan: true,
				firstMargin: true,
				paddingBottom: 4,
			},
		});
	});
};
init();
